import React from "react";
import Routes from "./Routes/Routes";


import "video-react/dist/video-react.css";
import { UserProvider } from "./Components/UserContext/UserProvider";
export default function App() {
  return (
    <UserProvider>

      <Routes />
    </UserProvider>
  )
}
